import FocusableOverlaidImage, {
    FocusableOverlaidImageProps,
} from '@rhg/components/focusable-overlaid-image';

const CardImage = FocusableOverlaidImage;
export type CardImageProps = FocusableOverlaidImageProps;
export default CardImage;
